import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetPlanReviewForResubmissionQueryVariables = Types.Exact<{
  id: Types.Scalars['uuid']['input'];
}>;


export type GetPlanReviewForResubmissionQuery = { __typename?: 'query_root', plan_reviews_by_pk?: { __typename?: 'plan_reviews', id: any, organization_id?: any | null, property_id: any, jurisdiction_id?: any | null, submission_type_id?: any | null, property: { __typename?: 'properties', id: any, name: string }, plan_review_jobs: Array<{ __typename?: 'plan_review_jobs', id: any, submission_number: number, state: string }> } | null };


export const GetPlanReviewForResubmissionDocument = gql`
    query getPlanReviewForResubmission($id: uuid!) {
  plan_reviews_by_pk(id: $id) {
    id
    organization_id
    property_id
    jurisdiction_id
    submission_type_id
    property {
      id
      name
    }
    plan_review_jobs(order_by: {submission_number: desc}, limit: 1) {
      id
      submission_number
      state
    }
  }
}
    `;

/**
 * __useGetPlanReviewForResubmissionQuery__
 *
 * To run a query within a React component, call `useGetPlanReviewForResubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlanReviewForResubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlanReviewForResubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPlanReviewForResubmissionQuery(baseOptions: Apollo.QueryHookOptions<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables> & ({ variables: GetPlanReviewForResubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>(GetPlanReviewForResubmissionDocument, options);
      }
export function useGetPlanReviewForResubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>(GetPlanReviewForResubmissionDocument, options);
        }
export function useGetPlanReviewForResubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>(GetPlanReviewForResubmissionDocument, options);
        }
export type GetPlanReviewForResubmissionQueryHookResult = ReturnType<typeof useGetPlanReviewForResubmissionQuery>;
export type GetPlanReviewForResubmissionLazyQueryHookResult = ReturnType<typeof useGetPlanReviewForResubmissionLazyQuery>;
export type GetPlanReviewForResubmissionSuspenseQueryHookResult = ReturnType<typeof useGetPlanReviewForResubmissionSuspenseQuery>;
export type GetPlanReviewForResubmissionQueryResult = Apollo.QueryResult<GetPlanReviewForResubmissionQuery, GetPlanReviewForResubmissionQueryVariables>;